(() => {
  const init = () => {
    document.querySelectorAll('[data-ke-finder]:not([data-ready])').forEach(root => {
      root.dataset.ready = 'true';
      const material = root.querySelector('[data-material]');
      const operation = root.querySelector('[data-operation]');
      const diameter = root.querySelector('[data-diameter]');
      const stock = root.querySelector('[data-stock]');
      const products = [...root.querySelectorAll('[data-product]')];
      const allDiameterLabel = diameter.options[0].textContent;
      const baseMatch = product => (!material.value || product.dataset.iso.split(' ').includes(material.value)) && (!operation.value || product.dataset.operations.split(' ').includes(operation.value));
      const update = (rebuild = false) => {
        const hasSelection = !!(material.value || operation.value || diameter.value || stock.checked);
        if (rebuild) {
          const previous = diameter.value;
          const values = new Set();
          products.filter(baseMatch).forEach(p => p.querySelectorAll('[data-variant]').forEach(v => {
            if ((!stock.checked || v.dataset.available === 'true') && Number(v.dataset.diameter) > 0) values.add(Number(v.dataset.diameter));
          }));
          if (previous) values.add(Number(previous));
          diameter.replaceChildren(new Option(allDiameterLabel, ''), ...[...values].sort((a,b) => a-b).map(n => new Option(`Ø ${n} mm`, String(n))));
          if ([...diameter.options].some(o => o.value === previous)) diameter.value = previous;
        }
        let count = 0;
        products.forEach(p => {
          const visible = [...p.querySelectorAll('[data-variant]')].filter(v => {
            const match = baseMatch(p) && (!diameter.value || Number(v.dataset.diameter) === Number(diameter.value)) && (!stock.checked || v.dataset.available === 'true');
            v.hidden = !match;
            return match;
          });
          p.hidden = !visible.length;
          if (visible.length) {
            count++;
            p.querySelector('[data-variant-count]').textContent = `(${visible.length})`;
            const lowest = visible.reduce((a,b) => Number(a.dataset.price) <= Number(b.dataset.price) ? a : b);
            p.querySelector('[data-result-price]').textContent = lowest.dataset.money;
            p.querySelector('details').open = !!diameter.value;
          }
        });
        root.querySelector('[data-count]').textContent = (count===1?root.querySelector('[data-count]').dataset.one:root.querySelector('[data-count]').dataset.label).replace('[count]', count);
        root.querySelector('[data-empty]').hidden = !hasSelection || count > 0;
        root.querySelector('[data-results]').hidden = !hasSelection || count === 0;
        root.querySelector('[data-count]').hidden = !hasSelection;
        root.querySelector('[data-reset]').hidden = !hasSelection;
      };
      [material,operation,stock].forEach(el => el.addEventListener('change', () => update(true)));
      diameter.addEventListener('change', () => update());
      root.querySelector('[data-reset]').addEventListener('click', () => {material.value='';operation.value='';diameter.value='';stock.checked=false;update(true);});
      const reveal = () => { if (location.hash === '#werkzeugfinder') root.querySelector('[data-finder-panel]').open = true; };
      window.addEventListener('hashchange', reveal);
      document.querySelectorAll('a[href$="#werkzeugfinder"]').forEach(link => link.addEventListener('click', reveal));
      reveal();
      update(true);
    });
    document.querySelectorAll('[data-ke-config]:not([data-ready])').forEach(root => {
      root.dataset.ready = 'true';
      const panel = root.querySelector('[data-config-panel]');
      const reveal = () => { if (location.hash === '#werkzeug-konfigurator') panel.open = true; };
      window.addEventListener('hashchange', reveal);
      document.querySelectorAll('[data-ke-open-config]').forEach(link => link.addEventListener('click', () => { panel.open = true; }));
      reveal();
      const products = JSON.parse(root.querySelector('[data-config-data]').textContent);
      const variants = products.flatMap(p => p.variants.map(v => ({...v,product:p.id,productTitle:p.title,role:v.title.includes('Passende Wendeplatten')?'insert':p.role,thread:(v.title.match(/(?:^|-)\s*(M\d+(?:[.,]\d+)?)\s*(?:-|$)/i)?.[1] || '').toUpperCase()})));
      const roles = ['head','holder','insert'];
      const selects = Object.fromEntries(roles.map(role => [role,root.querySelector(`[data-select="${role}"]`)]));
      const qty = Object.fromEntries(roles.map(role => [role,root.querySelector(`[data-qty="${role}"]`)]));
      const selected = role => variants.find(v => String(v.id) === selects[role].value);
      const money = n => new Intl.NumberFormat(`${root.dataset.locale.split('-')[0]}-CH`, {style:'currency',currency:root.dataset.currency}).format(n/100);
      const fill = (role, list) => {
        const previous=selects[role].value;
        selects[role].replaceChildren(new Option(root.dataset.choose,''),...list.map(v => {
          const title = role==='head'?`${v.productTitle} · ${v.title}`:v.title.replace('Passende Wendeplatten – ','');
          const o = new Option(`${title} · ${v.sku}${v.available?'':` · ${root.dataset.unavailable}`}`,String(v.id));
          o.disabled=!v.available;
          return o;
        }));
        if(list.some(v => String(v.id)===previous)) selects[role].value=previous;
      };
      const source = products.find(p => String(p.id)===root.dataset.product);
      const anchor = source?.role==='holder'?'holder':'head';
      const eligible = v => v.role !== 'head' || source?.role !== 'head' || v.product === source.id;
      const refresh = changed => {
        const fixed=selected(anchor);
        const other=anchor==='head'?'holder':'head';
        fill(anchor,variants.filter(v=>v.role===anchor && eligible(v)));
        fill(other,variants.filter(v=>v.role===other && eligible(v) && (!fixed || (fixed.thread && v.thread===fixed.thread))));
        const head=selected('head');
        fill('insert',variants.filter(v=>v.role==='insert' && head && v.product===head.product));
        selects.insert.disabled=!head;
        updateTotal();
      };
      const updateTotal = () => {
        let total=0;
        let complete=true;
        roles.forEach(role=>{
          const v=selected(role),n=Number(qty[role].value);
          const valid=Number.isInteger(n)&&n>=1&&n<=999;
          if(!v||!v.available||!valid) complete=false;
          root.querySelector(`[data-price="${role}"]`).textContent=v&&valid?money(v.price*n):'—';
          root.querySelector(`[data-meta="${role}"]`).textContent=v?`${v.sku} · ${v.title.replace('Passende Wendeplatten – ','')} · ${v.available?root.dataset.available:root.dataset.unavailable}`:'';
          if(v&&valid)total+=v.price*n;
        });
        const h=selected('head'),a=selected('holder'),i=selected('insert');
        complete=!!(complete&&h?.thread&&h.thread===a?.thread&&h.product===i?.product);
        root.querySelector('[data-total]').textContent=money(total);
        root.querySelector('[data-add]').disabled=!complete;
        root.querySelector('[data-status]').textContent=complete?`${root.dataset.compatible} · ${h.thread}`:root.dataset.incomplete;
      };
      roles.forEach(role=>{fill(role,variants.filter(v=>v.role===role && eligible(v)));selects[role].addEventListener('change',()=>refresh(role));qty[role].addEventListener('input',updateTotal);});
      const current=variants.find(v=>String(v.id)===root.dataset.current);
      if(current&&current.role!=='insert')selects[current.role].value=String(current.id);
      refresh();
      const form=root.querySelector('[data-config-form]');form.hidden=false;
      const addLabel=root.querySelector('[data-add]').textContent;
      window.addEventListener('pageshow',event=>{
        if(!event.persisted)return;
        form.dataset.busy='false';
        roles.forEach(role=>{selects[role].disabled=false;qty[role].disabled=false;});
        root.querySelector('[data-add]').textContent=addLabel;refresh();
      });
      form.addEventListener('submit',async event=>{
        event.preventDefault();
        if(form.dataset.busy==='true')return;
        updateTotal();
        const button=root.querySelector('[data-add]');
        if(button.disabled||!form.reportValidity())return;
        const label=button.textContent;
        form.dataset.busy='true';button.disabled=true;button.textContent=root.dataset.busy;
        roles.forEach(role=>{selects[role].disabled=true;qty[role].disabled=true;});
        try{
          const response=await fetch(`${root.dataset.root.replace(/\/$/,'')}/cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:roles.map(role=>({id:Number(selects[role].value),quantity:Number(qty[role].value)}))})});
          const data=await response.json();
          if(!response.ok)throw new Error(typeof data.description==='string'?data.description:root.dataset.error);
          window.location.assign(root.dataset.cart);
        }catch(error){
          form.dataset.busy='false';roles.forEach(role=>{selects[role].disabled=false;qty[role].disabled=false;});button.textContent=label;updateTotal();root.querySelector('[data-status]').textContent=error.message||root.dataset.error;
        }
      });
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
